import { Document, Image, Page, Text, View } from '@react-pdf/renderer'
import React from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import Html from 'react-pdf-html'
import { LicensingBillingForPDF } from './LicensingBillingForPDF'
import { styles } from './licensingBillingPdfStyles'
import CCLogo from '../../../../Images/Branding/cc-combination-blue.png'
import { LicensingBill, LicensingPayment } from '../../../../swagger'
import { useTranslation } from 'react-i18next'
import { dateTimeFormatter } from '../../../../utils/dateUtility'

export const LicensingBillingPDF: React.FC<{
  licensingBills: LicensingBill[]
  fullName: string
  licensingHistory: LicensingPayment[]
}> = ({ licensingBills, fullName, licensingHistory }) => {
  const { t } = useTranslation()

  const preparedOnDate = dateTimeFormatter
    .format(new Date())
    .replace(/\//g, '-')

  return (
    <Document title="Billing">
      <Page size="LETTER" style={styles.page}>
        <Image style={styles.logo} src={CCLogo} />
        <View style={styles.billToContainer}>
          <Text style={styles.billToLabel}>
            {t(
              'Billing.PDFPreview.BillTo',
              'Program Licensing for {{ fullName }}',
              {
                fullName,
              }
            )}
          </Text>
        </View>
        <Html>
          {renderToStaticMarkup(
            <LicensingBillingForPDF
              licensingBills={licensingBills}
              licensingHistory={licensingHistory}
            />
          )}
        </Html>
        <View style={styles.preparedOnDateContainer}>
          <Text style={styles.preparedOnDate}>
            {t(
              'Billing.PDFPreview.PreparedOn',
              'Prepared on {{ preparedOnDate }}',
              {
                preparedOnDate,
              }
            )}
          </Text>
        </View>
      </Page>
    </Document>
  )
}
